import React from "react";
import firebase, { auth, db } from '../../settings/firebase';
import { makeStyles } from '@material-ui/core/styles';
// import GoogleIcon from '../../img/google.png';
import { GoogleIcon, TwitterIcon, FacebookIcon, LoginBorderLine } from '../SVG/SnsIcon';
import './LoginProvider.css';

const useStyles = makeStyles((theme) => ({
  providerSigninBtn: {
    borderRadius: "10px",
    height: "41px",
    width: "191px",
    backgroundColor: "#ffffff",
    border: "1px solid #000",
  }
}))
// Google認証
export async function SignupLoginHandler(user) {
  db.collection("users").doc(user.uid).get().then(async doc => {
    if (!doc.exists) {
      await db.collection("users").doc(user.uid).set({
        pageUrl: "",
        name: user.displayName,
        displayid: user.uid,
        avatarUrl: user.photoURL,
        intro: "",
        favorite: [],
        follow: 0,
        follower: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      await db.collection("displayids").doc(user.uid).set({
        uid: user.uid,
      });
    }
  })
}

// プロバイダー経由サインインボタン
function ProviderSigninText(props) {
  const { onClick, children } = props;
  return (
    <button className={"providerSigninBtn "} style={{border: "2px solid", margin: "5px"}} onClick={onClick}>
      {children}
    </button>
  )
};
  
export default class LoginProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {google: props.google, twitter: props.twitter, facebook: props.facebook}
  }

  render() {
    return (
      <div style={{display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center"}}>
        <ProviderSigninText onClick={this.state.google}>
          <GoogleIcon className={"loginicon"} /><span className={"loginprovlabel"}>Googleで認証する</span>
        </ProviderSigninText>
        <ProviderSigninText onClick={this.state.twitter}>
          <TwitterIcon className={"loginicon"} /><span className={"loginprovlabel"}>Twitterで認証する</span>
        </ProviderSigninText>
        <ProviderSigninText onClick={this.state.facebook}>
          <FacebookIcon className={"loginicon"} /><span className={"loginprovlabel"}>Facebookで認証する</span>
        </ProviderSigninText>
        {/* <ProviderSigninText className={"login-apple-btn"} onClick={this.appleLoginHandler}>Appleでログイン</ProviderSigninText> */}
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <LoginBorderLine />　または　<LoginBorderLine />
        </div>
      </div>
    )
  }
}